/* eslint-disable react-hooks/exhaustive-deps */
import SectionHero from "../../Components/SectionHero/SectionHero";
import UnlockPoints from "../../Components/UnlockPoints/UnlockPoints";
import ImageSection from "../../Components/ImageSection/ImageSection";
import TrendingGiftCards from "../../Components/TrendingGiftCard/TrendingGiftCards";
import TopSellingBrands from "../../Components/TopSellingBrands/TopSellingBrands";
import { useEffect, useState } from "react";
import { trackEvent } from "../../Components/Utility/Utility";
import ShopByCategoryOptimized from "../../Components/shopByCategory/ShopByCategoryOptimized";
import SessionExpiredModal from "../SessionExpired/SessionExpiredModal";

const HomePage = () => {
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    document.body.classList.remove("no-scroll");
    trackEvent("page_browse", {
      page_title: "Home Page",
      page_url: window.location.href,
    });
    if (sessionStorage.getItem("sessionExpired") === "true") {
      setSessionExpired(true);
      sessionStorage.setItem("blockDirectUrl", true)
      sessionStorage.removeItem("sessionExpired");
      setTimeout(() => {
        sessionStorage.removeItem("blockDirectUrl");
      }, 1000);
    }
  }, []);

  return (
    <>
      <SessionExpiredModal
        isOpen={sessionExpired}
        onClose={() => {
          setSessionExpired(false);
        }}
      />
      <SectionHero />
      <UnlockPoints />
      <ShopByCategoryOptimized />
      <ImageSection />
      <TrendingGiftCards />
      <TopSellingBrands />
    </>
  );
};

export default HomePage;
